(function () {
  'use strict';

  /* ============================================
     SP CART PANEL — assets/sp-cart-panel.js
     Studio Phalsa Custom Cart
     ============================================ */

  /* ─── DOM REFERENCES ─── */
  const panel      = document.getElementById('sp-cart-panel');
  const backdrop   = document.getElementById('sp-cart-backdrop');
  const closeBtn   = document.getElementById('sp-cart-close');
  const countEl    = document.getElementById('sp-cart-count');
  const itemsList  = document.getElementById('sp-cart-items-list');
  const emptyState = document.getElementById('sp-cart-empty');
  const subtotalEl = document.getElementById('sp-cart-subtotal');
  const discountAmountEl = document.getElementById('sp-cart-discount-amount'); //new add
  const totalEl = document.getElementById('sp-cart-total'); // new add
  const discountToggle = document.getElementById('sp-cart-discount-toggle');
  const discountWrap   = document.getElementById('sp-cart-discount-wrap');

  /* ─── STATE ─── */
  let isOpen   = false;
  let isLoading = false;

  /* ─── OPEN ─── */
  function openCartPanel() {
    if (!panel) return;
    fetchCart().then(renderCart);
    panel.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    panel.setAttribute('aria-hidden', 'false');
  }

  /* ─── CLOSE ─── */
  function closeCartPanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    isOpen = false;
    panel.setAttribute('aria-hidden', 'true');
  }

  /* ─── FETCH CART ─── */
  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(res => res.json())
    .catch(err => {
      console.error('SP Cart: fetch error', err);
      return null;
    });
  }

  /* ─── FORMAT PRICE ─── */
  function formatPrice(cents) {
    const amount = (cents / 100).toFixed(2);
    const parts = amount.split('.');
    const intPart = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g, ','
    );
    return '₹' + intPart + '.' + parts[1];
  }

  /* ─── PARSE VARIANT TITLE ─── */
  function parseVariant(variantTitle) {
    if (!variantTitle || variantTitle === 'Default Title') {
      return { colour: '', size: '' };
    }
    const parts = variantTitle.split(' / ');
    return {
      colour: parts[0] || '',
      size: parts[1] || ''
    };
  }

  /* ─── RENDER CART ─── */
  function renderCart(cart) {
    if (!cart) return;

    const count = cart.item_count || 0;

    /* Update count in header */
    if (countEl) {
      countEl.textContent = '(' + count + ')';
    }

    /* Update all navbar cart badges */
    updateCartBadge(count);

    /* Notify other components of the current cart state */
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        data: {
          itemCount: count,
          source: 'sp-cart-panel'
        }
      }
    }));
    // old code -- commented
    /* Update subtotal */
    // if (subtotalEl) {
    //   subtotalEl.textContent = formatPrice(cart.total_price);
    // }

    // new code
    /* Update subtotal, discount and final total */
    if (subtotalEl) {
      subtotalEl.textContent = formatPrice(
        cart.original_total_price ?? cart.total_price
      );
    }

    if (discountAmountEl) {
      discountAmountEl.textContent = '-' + formatPrice(
        cart.total_discount || 0
      );
    }

    if (totalEl) {
      totalEl.textContent = formatPrice(cart.total_price);
    }
    // new code ends

    /* Update shipping display — Shopify doesn't return a shipping
       cost from /cart.js (it's calculated at checkout from the
       customer's address), so show an honest placeholder instead
       of a hardcoded "FREE". */
    const shippingEl = document.querySelector(
      '.sp-cart__shipping-value'
    );
    if (shippingEl) {
      shippingEl.textContent = 'Free shipping across India.';
    }

    if (count === 0) {
      /* Show empty state */
      if (emptyState) {
        emptyState.classList.remove('is-hidden');
      }
      if (itemsList) {
        itemsList.classList.add('is-hidden');
        itemsList.innerHTML = '';
      }
      return;
    }

    /* Hide empty state show items */
    if (emptyState) {
      emptyState.classList.add('is-hidden');
    }
    if (itemsList) {
      itemsList.classList.remove('is-hidden');
    }

    /* Render each item */
    if (itemsList) {
      itemsList.innerHTML = cart.items.map(
        item => renderItem(item)
      ).join('');

      /* Wire up buttons after render */
      wireItemButtons();
    }
  }

  /* ─── RENDER SINGLE ITEM ─── */
  function renderItem(item) {
    const variant  = parseVariant(item.variant_title);
    const price    = formatPrice(item.price);
    const imageUrl = item.featured_image
      ? item.featured_image.url
      : '';
    const imageHtml = imageUrl
      ? '<img class="sp-cart__item-image" src="'
        + imageUrl + '" alt="'
        + escapeHtml(item.product_title)
        + '" width="182" height="248" loading="eager">'
      : '<div class="sp-cart__item-image sp-cart__item-image--placeholder"></div>';

    const colourHtml = variant.colour
      ? '<p class="sp-cart__item-variant">Color: '
        + escapeHtml(variant.colour) + '</p>'
      : '';

    const sizeHtml = variant.size
      ? '<p class="sp-cart__item-variant">Size: '
        + escapeHtml(variant.size) + '</p>'
      : '';

    return [
      '<div class="sp-cart__item" data-key="'
        + escapeHtml(item.key) + '">',

        '<a href="' + item.url
          + '" class="sp-cart__item-image-wrap">',
          imageHtml,
        '</a>',

        '<div class="sp-cart__item-details">',

          '<div class="sp-cart__item-top">',
            '<a href="' + item.url
              + '" class="sp-cart__item-name">',
              escapeHtml(item.product_title),
            '</a>',
            '<span class="sp-cart__item-price">'
              + price + '</span>',
          '</div>',

          colourHtml,
          sizeHtml,

          '<div class="sp-cart__item-actions">',
            '<span class="sp-cart__qty-label">'
              + 'Quantity:</span>',

            '<button class="sp-cart__qty-btn '
              + 'sp-cart__qty-btn--minus" '
              + 'data-key="' + escapeHtml(item.key)
              + '" data-action="decrease" '
              + 'aria-label="Decrease quantity"'
              + (item.quantity <= 1
                ? ' disabled' : '') + '>',
              '−',
            '</button>',

            '<span class="sp-cart__qty-number" '
              + 'id="sp-qty-'
              + escapeHtml(item.key) + '">',
              item.quantity,
            '</span>',

            '<button class="sp-cart__qty-btn '
              + 'sp-cart__qty-btn--plus" '
              + 'data-key="' + escapeHtml(item.key)
              + '" data-action="increase" '
              + 'aria-label="Increase quantity">',
              '+',
            '</button>',

            '<span class="sp-cart__divider" '
              + 'aria-hidden="true"></span>',

            '<button class="sp-cart__remove-btn" '
              + 'data-key="' + escapeHtml(item.key)
              + '" aria-label="Remove item">',
              '<svg width="20" height="20" '
                + 'viewBox="0 0 24 24" fill="none" '
                + 'stroke="currentColor" '
                + 'stroke-width="1.5">',
                '<polyline points="3 6 5 6 21 6"/>',
                '<path d="M19 6l-1 14a2 2 0 '
                  + '01-2 2H8a2 2 0 01-2-2L5 6"/>',
                '<path d="M10 11v6M14 11v6"/>',
                '<path d="M9 6V4a1 1 0 011-1h4'
                  + 'a1 1 0 011 1v2"/>',
              '</svg>',
            '</button>',

          '</div>',

        '</div>',

      '</div>'
    ].join('');
  }

  /* ─── WIRE ITEM BUTTONS ─── */
  function wireItemButtons() {
    if (!itemsList) return;

    /* Quantity buttons */
    itemsList.querySelectorAll(
      '.sp-cart__qty-btn'
    ).forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const key    = this.dataset.key;
        const action = this.dataset.action;
        const qtyEl  = document.getElementById(
          'sp-qty-' + key
        );
        const currentQty = parseInt(
          qtyEl ? qtyEl.textContent : 1
        );
        const newQty = action === 'increase'
          ? currentQty + 1
          : currentQty - 1;
        if (newQty < 1) return;
        updateQuantity(key, newQty);
      });
    });

    /* Remove buttons */
    itemsList.querySelectorAll(
      '.sp-cart__remove-btn'
    ).forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        removeItem(this.dataset.key);
      });
    });
  }

  /* ─── UPDATE QUANTITY ─── */
  function updateQuantity(key, newQty) {
    if (isLoading) return;
    setLoading(true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: newQty
      })
    })
    .then((res) => res.json().then((payload) => ({ res, payload })))
    .then(({ res, payload }) => {
      if (!res.ok || payload?.errors || payload?.status >= 400) {
        return Promise.reject(payload);
      }
      renderCart(payload);
    })
    .catch((err) => {
      console.error('SP Cart: update error', err);
      fetchCart().then(renderCart);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  /* ─── REMOVE ITEM ─── */
  function removeItem(key) {
    if (isLoading) return;
    setLoading(true);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then((res) => res.json().then((payload) => ({ res, payload })))
    .then(({ res, payload }) => {
      if (!res.ok || payload?.errors || payload?.status >= 400) {
        return Promise.reject(payload);
      }
      renderCart(payload);
    })
    .catch((err) => {
      console.error('SP Cart: remove error', err);
      fetchCart().then(renderCart);
    })
    .finally(() => {
      setLoading(false);
    });
  }

  /* ─── LOADING STATE ─── */
  function setLoading(state) {
    isLoading = state;
    const itemsEl = document.getElementById(
      'sp-cart-items'
    );
    if (itemsEl) {
      itemsEl.classList.toggle('is-loading', state);
    }
  }

  /* ─── UPDATE NAVBAR CART BADGE ─── */
  function updateCartBadge(count) {
    const badges = document.querySelectorAll(
      '.sp-navbar__cart-badge, '
      + '.sp-navbar__cart-count, '
      + '#sp-cart-badge'
    );
    badges.forEach(badge => {
      badge.textContent  = count > 0 ? count : '';
      badge.style.display = count > 0
        ? 'flex' : 'none';
    });

    /* Also trigger Horizon's native badge update */
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: { count: count }
      })
    );
  }

  /* ─── ESCAPE HTML ─── */
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ─── DISCOUNT TOGGLE ─── */
  function initDiscountToggle() {
    if (!discountToggle || !discountWrap) return;
    discountToggle.addEventListener('click', () => {
      discountWrap.classList.toggle('is-open');
      const input = discountWrap.querySelector(
        '.sp-cart__discount-input'
      );
      if (input && discountWrap.classList
          .contains('is-open')) {
        input.focus();
      }
    });
  }

  //New code for discount

  
  /* ─── APPLY DISCOUNT CODE ─── */
  function applyDiscountCode() {
    const input = document.getElementById('sp-cart-discount-input');
    const applyBtn = document.getElementById('sp-cart-discount-apply');
    const discountWrap = document.getElementById('sp-cart-discount-wrap');

    if (!input || !applyBtn) return;

    const code = input.value.trim();

    if (!code) {
      showDiscountMessage('Please enter a discount code.', 'error');
      return;
    }

    applyBtn.disabled = true;
    applyBtn.textContent = 'Applying...';

    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    })
      // .then(response => {
      //   if (!response.ok) {
      //     throw new Error('Unable to submit discount code.');
      //   }

      //   showDiscountMessage(
      //     'Discount code submitted. It will be applied at checkout if eligible.',
      //     'success'
      //   );

      //   input.value = '';
      // })
      .then(response => {
        if (!response.ok) {
          throw new Error('Unable to submit discount code.');
        }

        fetchCart().then(cart => {
          if (cart) {
            renderCart(cart);
          }

          showDiscountMessage(
            'Discount code submitted. Check the updated total below.',
            'success'
          );
        });

        input.value = '';
      })
      .catch(error => {
        console.error('SP Cart: discount error', error);
        showDiscountMessage(
          'Something went wrong. Please try again.',
          'error'
        );
      })
      .finally(() => {
        applyBtn.disabled = false;
        applyBtn.textContent = 'Apply';
      });
  }

  /* ─── DISCOUNT MESSAGE ─── */
  function showDiscountMessage(message, type) {
    let messageEl = document.getElementById('sp-discount-message');

    if (!messageEl) {
      messageEl = document.createElement('p');
      messageEl.id = 'sp-discount-message';

      const discountWrap = document.getElementById(
        'sp-cart-discount-wrap'
      );

      if (discountWrap) {
        discountWrap.appendChild(messageEl);
      }
    }

    if (messageEl) {
      messageEl.textContent = message;
      messageEl.style.color = type === 'success' ? '#287a42' : '#c0392b';
      messageEl.style.fontSize = '12px';
      messageEl.style.marginTop = '8px';
    }
  }
  // new code ends for discount

  /* ─── EVENT LISTENERS ─── */
  function initEvents() {
    /* Close button */
    if (closeBtn) {
      closeBtn.addEventListener(
        'click', closeCartPanel
      );
    }

    /* Backdrop click */
    if (backdrop) {
      backdrop.addEventListener(
        'click', closeCartPanel
      );
    }

    /* Escape key */
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && isOpen) {
        closeCartPanel();
      }
    });

    /* Discount toggle */
    initDiscountToggle();

    // new code for discount
    /* Apply discount code */
    const applyDiscountBtn = document.getElementById(
      'sp-cart-discount-apply'
    );

    if (applyDiscountBtn) {
      applyDiscountBtn.addEventListener('click', function(e) {
        e.preventDefault();
        applyDiscountCode();
      });
    }
  }

  /* ─── INIT ─── */
  function init() {
    if (!panel) return;
    initEvents();

    /* Initial badge fetch */
    fetchCart().then(cart => {
      if (cart) updateCartBadge(cart.item_count);
    });
  }

  /* ─── PUBLIC API ─── */
  window.spCartPanel = {
    open:  openCartPanel,
    close: closeCartPanel,
    refresh: function() {
      fetchCart().then(renderCart);
    }
  };

  /* ─── BOOT ─── */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded', init
    );
  } else {
    init();
  }

})();
